import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/order'

/**
 * @description: 获取订单列表
 * @param {*} params
 * @return {*}
 */
export function getList(params) {
  return axios.get(`${ApiUrl}/list/`, {
    params
  })
}

/**
 * @description: 订单详情
 * @param {*} sn
 * @return {*}
 */
export function getDetail(sn) {
  return axios.get(`${ApiUrl}/${sn}/detail/`)
}

/**
 * @description: 订单详情-简要
 * @param {*} sn
 * @return {*}
 */
export function getBrief(sn) {
  return axios.get(`${ApiUrl}/${sn}/brief/`)
}

/**
 * @description: 修改订单
 * @param {*} sn
 * @param {*} data
 * @return {*}
 */
export function edit(sn, data) {
  return axios.put(`${ApiUrl}/${sn}/edit/`, data)
}

/**
 * @description: 核单
 * @param {*} sn
 * @param {*} data
 * @return {*}
 */
export function consume(sn, data) {
  return axios.post(`${ApiUrl}/${sn}/consume/`, data)
}

/**
 * @description: 批量核单
 * @param {*} data
 * @return {*}
 */
export function consumeBatch(data) {
  return axios.post(`${ApiUrl}/consume/batch/`, data)
}

/**
 * @description: 编辑备注
 * @param {*} sn
 * @param {*} data
 * @return {*}
 */
export function putRemark(sn, data) {
  return axios.put(`${ApiUrl}/${sn}/edit_remark/`, data)
}

/**
 * @description: 购票记录
 * @param {*} sn
 * @return {*}
 */
export function getTicketRecord(sn) {
  return axios.get(`${ApiUrl}/${sn}/ticket_record/list/`)
}

/**
 * @description: 重发短信
 * @param {*} data
 * @return {*}
 */
export function sendMsg(ticket_record_id, data) {
  return axios.post(`${ApiUrl}/ticket_record/${ticket_record_id}/send_msg/`, data)
}

/**
 * @description: 退款
 * @return {*}
 */
export function postRefund(ticket_record_id, data) {
  return axios.post(`${ApiUrl}/ticket_record/${ticket_record_id}/refund/`, data)
}

/**
 * @description: 全部退票
 * @return {*}
 */
export function refundTickets(sn) {
  return axios.post(`${ApiUrl}/${sn}/refund_tickets/`)
}

/**
 * @description:手动录入订单
 */
export function manualAddOrder(data) {
  return axios.post(`${ApiUrl}/manual_add_order/`, data)
}

/**
 * @description: 取消订单
 * @return {*}
 */
export function cancelOrder(sn) {
  return axios.post(`${ApiUrl}/${sn}/cancel/`)
}

export function exportOrders(params) {
  return axios.get(`${ApiUrl}/export/`, { params })
}

export function closeOrder(sn) {
  return axios.post(`${ApiUrl}/${sn}/close/`)
}

/**
 * @description: 派发门票
 */
export function assignTicket(order_id) {
  return axios.post(`${ApiUrl}/assign_ticket/`, { order_id })
}

export function downloadPdf(sn) {
  return axios.get(`${ApiUrl}/${sn}/download_pdf/`, {
    responseType: 'blob'
  })
}
